class UpdateContent {
  constructor(
    targetProductInfo,
    targetContainer,
    productLinkingOptionsContainer
  ) {
    this.targetProductInfo = targetProductInfo;
    this.container = targetContainer;
    this.$productLinkingOptionsContainer = productLinkingOptionsContainer;
  }

  replaceContent(selector, itemClass) {
    // Obtenemos el elemento que desamos reemplazar
    const $itemToReplace = document.querySelector(selector);

    // Si no existe el elemento en la page actual no hacemos nada
    if ($itemToReplace == null) {
      return;
    }

    // obtenemos el nuevo elemento
    const $newItem = this.targetProductInfo.content.querySelector(selector);

    // Si no existe el elemento nuevo escondemos el viejo
    if ($newItem == null) {
      $itemToReplace.classList.add("hidden");
      return;
    }

    // si tiene una custom class, se la agregamos.
    if (itemClass != null) {
      $newItem.classList.add(itemClass);
    }

    // Remplazamops el viejo contenido, por el nuevo
    $itemToReplace.replaceWith($newItem.cloneNode(true));
  }

  updateContent() {
    this.productInfo();
    this.productForm();
    this.productCarousel();
    this.tabsSection();
    this.relatedProducts();
    this.productLinkingData();
    this.updateURL();
    this.updateApps();
  }

  productInfo() {
    this.replaceContent(".product .product-meta-wrapper");
    this.replaceContent("head title");
    this.replaceContent(".breadcrumb__item.name");
    this.replaceContent(".shopify-section.shopify-section--faq");
    this.replaceContent(".product-add-ons-content");
  }

  productForm() {
    // this.replaceContent('.product .product__info');
    this.replaceContent(".product .product-form");
    this.replaceContent(".product-sticky-form");
  }

  productCarousel() {
    this.replaceContent(".product .product__media");
    this.replaceContent(".product .product-image-zoom");
  }

  tabsSection() {
    this.replaceContent("#main .shopify-section--product-content");
  }

  relatedProducts() {
    // this.replaceContent('#main .shopify-section--product-recommendations');
    this.replaceContent('.shopify-app-block[id*="rebuy"]');
  }

  /* Replace ProductLinking data */
  productLinkingData() {
    this.productJsons();
    this.updateProductLinkigLabels();
  }

  productJsons() {
    this.replaceContent("#product_json");
    this.replaceContent("#product_linking_json");
    this.replaceContent("#product_variants");
  }

  updateProductLinkigLabels() {
    const $value = this.$productLinkingOptionsContainer.querySelector(
      ".product-linking-name"
    );
    const valueText =
      this.targetProductInfo.product_linking_name == null
        ? ""
        : this.targetProductInfo.product_linking_name;

    $value.innerText = valueText;
  }

  updateURL() {
    const pathWithoutProduct = window.location.pathname.substring(
      0,
      window.location.pathname.lastIndexOf("/")
    );
    const newUrl = `${window.location.origin}${pathWithoutProduct}/${this.targetProductInfo.handle}`;
    window.history.replaceState({}, "", newUrl);
  }

  // Apps
  updateApps() {
    this.updateRebuy();
    // this.updateRecharge();
  }

  // eslint-disable-next-line @shopify/prefer-early-return
  updateRebuy() {
    if (window.Rebuy != null && window.Rebuy.init != null) {
      window.console.log(window.Rebuy);
      window.Rebuy.reinit();
      if (window.Rebuy.SmartCart != null) {
        window.Rebuy.SmartCart.unbindEvents();
        window.Rebuy.SmartCart.bindEvents();
      }
    }
  }

  updateRecharge() {
    const $jsonContainer = this.container.querySelector("#product_json");
    let currentProductJson = $jsonContainer.innerHTML.trim();
    currentProductJson = JSON.parse(currentProductJson);

    const settings = {
      productId: currentProductJson.product.id,
      injectionParent: 'form[action*="cart/add"] #recharge-widget',
      injectionMethod: "append",
    };

    window.ReChargeWidget.createWidget(settings);
  }
}

class ProductLinking {
  constructor(container) {
    this.container = container;
    // checamos que el producto actual cuente con product_linking, si no no hacemos nada
    const currentProductHasProductLinkingMetafields =
      this.container.dataset.hasProductLinkig === "true";
    if (currentProductHasProductLinkingMetafields === false) {
      return;
    }

    // Obtenemos el nodo contenedor de las opciones del product linking
    this.$productLinkingOptionsContainer = this.container.querySelector(
      ".product-linking-container"
    );

    // obtenemos valores de product_linking del product actual
    this.productLinkingCurrentProduct =
      this.getProductLinkingJsonOnCurrentProduct();

    // mandamos a llamar a la funcion para obtener todos los productos de la tienda.
    this.getAllProductsPromise()
      .then((products) => {
        this.products = products;
        this.initProductLinkingOptions();
      })
      .catch((error) => {
        window.console.log(error);
      });
  }

  async getAllProductsPromise() {
    try {
      // Construimos el array de URLs para las llamadas Fetch
      const urls = [];
      const totalPages = Math.ceil(window.shopProductsCount / 1000);
      const plLink = this.productLinkingCurrentProduct.link;

      window.console.log({ totalPages, plLink });
      for (let page = 1; page <= totalPages; page++) {
        const url = `${window.location.origin}/search?q=${plLink}&type=product&view=product-linking&page=${page}`;
        urls.push(url);
      }

      // Realizar las llamadas Fetch y obtener un array de promesas
      const promisesFetch = urls.map((url) => window.fetch(url));

      // Esperar a que se resuelvan todas las promesas
      const responses = await Promise.all(promisesFetch);

      // Obtener los resultados de todas las respuestas, y se obtienen por página
      const resultsByPage = await Promise.all(
        responses.map((response) => response.json())
      );

      // Pasamos todo a un solo array en lugar de un array de resultados por páginas
      const results = [].concat(...resultsByPage);
      return results;
    } catch (error) {
      // Manejo de errores
      window.console.error(error);
      return [];
    }
  }

  async getProductsContentPromise(products) {
    try {
      const urls = [];
      products.forEach((product) => {
        urls.push(product.product_url);
      });

      // Realizar las llamadas Fetch y obtener un array de promesas
      const promisesFetch = urls.map((url) => window.fetch(url));

      // Esperar a que se resuelvan todas las promesas
      const responses = await Promise.all(promisesFetch);

      // Obtener los resultados de todas las respuestas, y se obtienen por página
      const results = await Promise.all(
        responses.map((response) => response.text())
      );

      results.forEach((result, index) => {
        results[index] = new window.DOMParser().parseFromString(
          result,
          "text/html"
        );
      });

      return results;
    } catch (error) {
      // Manejo de errores
      window.console.error(error);
      return [];
    }
  }

  getProductLinkingJsonOnCurrentProduct() {
    // Function para obtener los valores del product_linkig del producto actual
    const $jsonContainer = this.container.querySelector(
      "#product_linking_json"
    );
    const currentProductJson = $jsonContainer.innerHTML.trim();
    return JSON.parse(currentProductJson);
  }

  buildProductLinkingOptions(products) {
    // Obtenemos los selectores necesarios, estaran disponibles si el producto actual tiene los metafields de product_linking
    const $productLinkingOptionsList =
      this.$productLinkingOptionsContainer.querySelector(
        ".product-linking-options-list"
      );
    const $optionTemplate =
      this.$productLinkingOptionsContainer.querySelector("template").content;

    // Crear un elemento div temporal y asignarle el contenido del template
    const tempDiv = document.createElement("div");
    tempDiv.appendChild($optionTemplate.cloneNode(true));
    const $optionHTML = tempDiv.innerHTML;

    // por cada producto hermano, pondremos la opción en HTML donde corresponde y su valor correspondiente.
    // su valor puede ser color_lino o color_terciopelo
    // Primero, ordenamos el array de productos si product_linking_orden no es null
    if (products.some((product) => product.product_linking_orden !== null)) {
      products.sort((a, b) => {
        // Si alguno de los productos no tiene product_linking_orden, lo colocamos al final
        if (a.product_linking_orden === null) return 1;
        if (b.product_linking_orden === null) return -1;
        // Ordenamos de manera ascendente
        return a.product_linking_orden - b.product_linking_orden;
      });
    }

    // Luego procedemos con el forEach
    products.forEach((product) => {
      // obtenemos el valor a reemplazar y la imagen.
      const optionName = product.product_linking_name;
      const optionId = product.id;
      const optionIsAvailable = product.available;
      const optionImage = product.image == null ? "" : product.image;

      // lo ponemos en el template
      let $newOptionHTML = $optionHTML.replace(
        /\[\[product_linking_name\]\]/g,
        optionName
      );
      $newOptionHTML = $newOptionHTML.replace(
        /\[\[product_linking_option_image\]\]/g,
        optionImage
      );
      $newOptionHTML = $newOptionHTML.replace(
        /\[\[product_linking_option_name\]\]/g,
        optionName
      );
      $newOptionHTML = $newOptionHTML.replace(
        /\[\[product_linking_id\]\]/g,
        optionId
      );
      $newOptionHTML = $newOptionHTML.replace(
        /\[\[available_class\]\]/g,
        optionIsAvailable ? "" : "is-disabled"
      );

      // creamos un div temporal para poder construir la opcion
      let tempElement = document.createElement("div");
      tempElement.innerHTML = $newOptionHTML;
      tempElement = tempElement.firstElementChild;

      // si el producto actual y la opcion es la misma, hacemos que se seleccione esta opcion
      if (product.id === this.productLinkingCurrentProduct.id) {
        tempElement.classList.add("selected");
        tempElement.querySelector("input").checked = true;
      }

      // agregamos esta opcion al DOM
      $productLinkingOptionsList.append(tempElement);
    });

    // mostramos las opciones
    this.$productLinkingOptionsContainer.classList.remove("hidden");
  }

  attachListenersToOptions() {
    // funcion para agregar los escuchas a las opciones de PL y saber cuando se ah cambiado de producto
    const productOptionsArray =
      this.$productLinkingOptionsContainer.querySelectorAll(
        ".product-linking-option-input"
      );
    productOptionsArray.forEach((productOption) => {
      productOption.addEventListener("change", () => {
        if (productOption.checked === false) {
          return;
        }

        this.onProductLinkingOptionClicked(productOption.value);
      });
    });
  }

  onProductLinkingOptionClicked(inputValue) {
    // funcion para realizar las acciones al momento de cambiar de producto.

    // obtenemos el producto seleccionado para empezar a remplazar todas las partes necesarias de la page
    const productID = parseInt(inputValue, 10);
    const productSelected = this.filteredProducts.find((product) => {
      if (productID === product.id) {
        return product;
      }
      return false;
    });

    const updateContent = new UpdateContent(
      productSelected,
      this.container,
      this.$productLinkingOptionsContainer
    );

    // Main section
    updateContent.updateContent();

    document.dispatchEvent(new window.Event("update::product_linking"));
  }

  initProductLinkingOptions() {
    // Los productos que recibimos ya son los que tienen el mismo product_linkin.link, debemos filtrar los que no cumplen ciertas condiciones.
    // - Deben existir el "name"
    // - Deben tener el mismo template
    this.filteredProducts = this.products.filter((product) => {
      if (product.product_linking_name == null) {
        return false;
      }

      if (
        product.template_suffix !==
        this.productLinkingCurrentProduct.template_suffix
      ) {
        return false;
      }

      return true;
    });

    // Si no hay productos "hermanos" entonces ya no hacemos nada
    if (this.filteredProducts.length < 1) {
      return;
    }

    // llamamos a la funcion que crea las opciones de los productos hermanos
    this.buildProductLinkingOptions(this.filteredProducts);
    this.attachListenersToOptions();

    // mandamos a llamar el contenido de todos los productos hermanos.
    this.getProductsContentPromise(this.filteredProducts)
      .then((productsContent) => {
        // Aqui ya tenemos el contenido de los productos

        // ponemos el contenido dentro del arreglo de los productos filtrados
        productsContent.forEach((productContent, index) => {
          this.filteredProducts[index].content = productContent;
        });

        this.$productLinkingOptionsContainer.classList.remove("disabled");
      })
      .catch((error) => {
        window.console.log(error);
      });
  }
}

class MainProduct extends HTMLElement {
  constructor() {
    super();
    // this.bindVariantRadios();

    this.productLinking = new ProductLinking(this);

    document.addEventListener("update::product_linking", () => {
      window.setTimeout(() => {
        // this.bindVariantRadios();
      }, 100);
    });
  }

  bindVariantRadios() {
    const $variantRadios = document.querySelectorAll(".block-swatch__radio");

    window.console.log({ $variantRadios });

    $variantRadios.forEach(($match) => {
      $match.addEventListener("change", (event) => {
        const variantID = parseInt(event.target.dataset.variantId, 10);
        const productVariantElement =
          document.querySelector("product-variants");
        productVariantElement.selectVariant(variantID);
      });
    });
  }
}

customElements.define("main-product", MainProduct);
